export default __webpack_public_path__ + "static/media/produits_sains-producteur.0c435d98.png";